import { render, staticRenderFns } from "./MyLunches.vue?vue&type=template&id=e2037cf4&scoped=true&"
import script from "./MyLunches.vue?vue&type=script&lang=js&"
export * from "./MyLunches.vue?vue&type=script&lang=js&"
import style0 from "./MyLunches.vue?vue&type=style&index=0&id=e2037cf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2037cf4",
  null
  
)

/* custom blocks */
import block0 from "./MyLunches.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports